export const BuildInfo = {timestamp:1771029332000}
